<script lang="ts">
	import '../app.postcss';
	// Setup Popups. See https://www.skeleton.dev/utilities/popups
	import { computePosition, autoUpdate, offset, shift, flip, arrow } from '@floating-ui/dom';
	import { storePopup } from '@skeletonlabs/skeleton';
	storePopup.set({ computePosition, autoUpdate, offset, shift, flip, arrow });
</script>

<!--<div class="h-screen bg-white">-->
<div class="h-screen bg-white">
	<slot />
</div>
